import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { FilterAlt } from "@mui/icons-material";
import { CustomIconButton } from "../../../shared/CustomIconButton";
import axios from "axios";
import Search from "../../../shared/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BorderColorIcon from "@mui/icons-material/BorderColor";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import AddIcon from "@mui/icons-material/Add";

import { toast } from "react-toastify";
import { useFormik } from "formik";
import { Switch } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const MainSpefication = () => {
  const [currentPage, setCurrentPage] = useState(null);
  const [totalPage, setTotalPage] = useState(null);
  const superuserId = localStorage.getItem("is_superuser");
  const storeId = localStorage.getItem("store_id");
  const [data, setData] = useState([]);
  const [open, setOpen] = React.useState(false);

  const [categoryData, setCategoryData] = useState([]);
  const [page, setPage] = useState(1);

  // add product varient start
  const [categoryId, setCategoryId] = useState("");
  const [rowData, setRowData] = useState({});
  const [ids, setIds] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [name, setName] = useState("");

  // add product varient end

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const specificationData = () => {
    axios
      .get(
        `https://app1.crazzyhub.com/api/admin/product-specifications-list/?store_id=${storeId}&page=${page}&search=${searchQuery}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setData(response?.data?.data);
        setTotalPage(response?.data?.current_page)
        setCurrentPage(response?.data?.total_pages)
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    specificationData();
  }, [page,searchQuery]);

  const mainCategoryDataList = () => {
    axios
      .post(
        `https://app1.crazzyhub.com/api/admin/multivendor-show-main-category-list/`,
        {},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        console.log(
          "category list data===>",
          response?.data?.main_category_data
        );
        setCategoryData(response?.data?.main_category_data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    mainCategoryDataList();
  }, []);

  const submitCategory = () => {
    const reqbody = new FormData();
    reqbody.append("maincategory_id", categoryId);
    reqbody.append("specification_name", name);

    ids == null
      ? axios
          .post(
            `https://app1.crazzyhub.com/api/admin/product-specifications-list/?store_id=${storeId}`,
            reqbody,
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            }
          )
          .then((response) => {
            toast.success(response.data.message);
            specificationData();
            setName("");
            setCategoryId("")
            setIds(null);
            handleClose();
          })
          .catch((error) => {
            console.log("", error);
          })
      : axios
          .put(
            `https://app1.crazzyhub.com/api/admin/product-specifications-list/?store_id=${storeId}&product_specification_id=${ids}`,
            reqbody,
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            }
          )
          .then((response) => {
            toast.success(response.data.message);
            setRowData({});
            setName("");
            setIds(null);
            specificationData();
            handleClose();
          })
          .catch((error) => {
            console.log("", error);
          });
  };

  const previousPage = () => {
    if (page > 0) {
      setPage(page - 1);
    }
  };
  const nestPage = () => {
    setPage(page + 1);
  };

  const hangleCancel = () => {
    setRowData();
    setIds(null);
    setName("");
    setCategoryId("")
    handleClose();
  };

  const editFunctionality = (row) => {
    setIds(row?.id);
    setName(row?.specification_name);
    setRowData(row);
    handleOpen();
  };

  const deleteProduct = (event, id) => {
    event.preventDefault();

    const deleteData = window.confirm(
      "are you sure delete this product specification...!"
    );

    if (deleteData == true) {
      axios
        .delete(
          `https://app1.crazzyhub.com/api/admin/product-specifications-list/?store_id=${storeId}&product_specification_id=${id}`,
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          }
        )
        .then((response) => {
          toast.success(response.data.message);
          specificationData();
        })
        .catch((error) => {
          console.log("error page", error.response);
          console.log(error);
        });
    }
  };

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Manage Product Specification List
          </p>
        </div>
        <div className="p-2 pt-5">
          <Button variant="outlined" color="primary" onClick={handleOpen}>
            <AddIcon />
            Add Product Specification
          </Button>
        </div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            <input
              type="text"
              value={searchQuery}
              className="!border-3 !border-black mx-3 !w-72 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>
          <span>
            <div className="text-red-500 mx-3">
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style, width: 430 }}
                  className="rounded-2xl !border-0"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                  >
                    {ids === null
                      ? "Add Product Specification "
                      : "Update Product Specification "}
                  </div>
                  <div className="w-full">
                    {ids === null ? (
                      <>
                        <div className="">Select Main Category :</div>
                        <FormControl fullWidth>
                          <Select
                            id="demo-simple-select"
                            size="small"
                            name="main_category_id"
                            className="!mt-1"
                            value={categoryId}
                            onChange={(event) =>
                              setCategoryId(event.target.value)
                            }
                          >
                            {categoryData?.map((elem) => (
                              <MenuItem value={elem?.id}>
                                {elem?.category}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </>
                    ) : null}

                    <div className="mt-2">Specification Name :</div>
                    <input
                      size="small"
                      value={name}
                      onChange={(event) => setName(event.target.value)}
                      id="outlined-basic"
                      className="!w-[100%] !mt-1 border rounded border-gray-300 p-1"
                      name="product_name"
                    />
                  </div>
                  <Button
                    onClick={hangleCancel}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    color="success"
                    className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    onClick={submitCategory}
                  >
                    {ids == null ? "ADD" : "UPDATE"}
                  </Button>
                </Box>
              </Modal>
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {/* <TableCell className="!text-left !p-2">
                  <Checkbox className="!m-0 !text-black" />
                </TableCell> */}
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  SPECIFICATION HEADING
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  CATEGORY NAME
                </TableCell>
                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  EDIT
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.id ? row.id : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.specification_name ? row?.specification_name : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.maincategory?.category
                        ? row?.maincategory?.category
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <BorderColorIcon
                        className="text-green-400 mx-2"
                        onClick={() => editFunctionality(row)}
                      />
                      <DeleteForeverIcon
                        className="text-red-500 mx-2"
                        onClick={(event) => deleteProduct(event, row?.id)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
          style={{ marginRight: "0px" }}
        >
          <button className="!float-right">
            {currentPage}...{totalPage}
            <ArrowForwardIosIcon onClick={nestPage} />
          </button>
          <button className="float-right">
            <ArrowBackIosIcon onClick={previousPage} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MainSpefication;
